import _regeneratorRuntime from "/Users/anitalu/Desktop/internship/anitalu724.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/anitalu/Desktop/internship/anitalu724.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/anitalu/Desktop/internship/anitalu724.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/anitalu/Desktop/internship/anitalu724.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var _ImageDrawer_images;

import { downloadSvgImage, loadImage, replaceImageColor } from "./Utils";
export var ImageDrawer = /*#__PURE__*/function () {
  function ImageDrawer() {
    _classCallCheck(this, ImageDrawer);

    _ImageDrawer_images.set(this, void 0);

    __classPrivateFieldSet(this, _ImageDrawer_images, [], "f");
  }

  _createClass(ImageDrawer, [{
    key: "getSidesCount",
    value: function getSidesCount() {
      return 12;
    }
  }, {
    key: "getImages",
    value: function getImages(container) {
      var containerImages = __classPrivateFieldGet(this, _ImageDrawer_images, "f").find(function (t) {
        return t.id === container.id;
      });

      if (!containerImages) {
        __classPrivateFieldGet(this, _ImageDrawer_images, "f").push({
          id: container.id,
          images: []
        });

        return this.getImages(container);
      } else {
        return containerImages;
      }
    }
  }, {
    key: "addImage",
    value: function addImage(container, image) {
      var containerImages = this.getImages(container);
      containerImages === null || containerImages === void 0 ? void 0 : containerImages.images.push(image);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      __classPrivateFieldSet(this, _ImageDrawer_images, [], "f");
    }
  }, {
    key: "draw",
    value: function draw(context, particle, radius, opacity) {
      var _a, _b;

      var image = particle.image;
      var element = (_a = image === null || image === void 0 ? void 0 : image.data) === null || _a === void 0 ? void 0 : _a.element;

      if (!element) {
        return;
      }

      var ratio = (_b = image === null || image === void 0 ? void 0 : image.ratio) !== null && _b !== void 0 ? _b : 1;
      var pos = {
        x: -radius,
        y: -radius
      };

      if (!(image === null || image === void 0 ? void 0 : image.data.svgData) || !(image === null || image === void 0 ? void 0 : image.replaceColor)) {
        context.globalAlpha = opacity;
      }

      context.drawImage(element, pos.x, pos.y, radius * 2, radius * 2 / ratio);

      if (!(image === null || image === void 0 ? void 0 : image.data.svgData) || !(image === null || image === void 0 ? void 0 : image.replaceColor)) {
        context.globalAlpha = 1;
      }
    }
  }, {
    key: "loadShape",
    value: function loadShape(particle) {
      var _this = this;

      var _a, _b, _c;

      if (particle.shape !== "image" && particle.shape !== "images") {
        return;
      }

      var images = this.getImages(particle.container).images;
      var imageData = particle.shapeData;
      var image = images.find(function (t) {
        return t.source === imageData.src;
      });
      var imageRes;

      if (!image) {
        this.loadImageShape(particle.container, imageData).then(function () {
          _this.loadShape(particle);
        });
        return;
      }

      if (image.error) {
        return;
      }

      var color = particle.getFillColor();

      if (image.svgData && imageData.replaceColor && color) {
        imageRes = replaceImageColor(image, imageData, color, particle);
      } else {
        imageRes = {
          data: image,
          loaded: true,
          ratio: imageData.width / imageData.height,
          replaceColor: (_a = imageData.replaceColor) !== null && _a !== void 0 ? _a : imageData.replace_color,
          source: imageData.src
        };
      }

      if (!imageRes.ratio) {
        imageRes.ratio = 1;
      }

      var fill = (_b = imageData.fill) !== null && _b !== void 0 ? _b : particle.fill;
      var close = (_c = imageData.close) !== null && _c !== void 0 ? _c : particle.close;
      var imageShape = {
        image: imageRes,
        fill: fill,
        close: close
      };
      particle.image = imageShape.image;
      particle.fill = imageShape.fill;
      particle.close = imageShape.close;
    }
  }, {
    key: "loadImageShape",
    value: function () {
      var _loadImageShape = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(container, imageShape) {
        var source, image, imageFunc;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              source = imageShape.src;

              if (source) {
                _context.next = 3;
                break;
              }

              throw new Error("Error tsParticles - No image.src");

            case 3:
              _context.prev = 3;
              image = {
                source: source,
                type: source.substr(source.length - 3),
                error: false,
                loading: true
              };
              this.addImage(container, image);
              imageFunc = imageShape.replaceColor ? downloadSvgImage : loadImage;
              _context.next = 9;
              return imageFunc(image);

            case 9:
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](3);
              throw new Error("tsParticles error - ".concat(imageShape.src, " not found"));

            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 11]]);
      }));

      function loadImageShape(_x, _x2) {
        return _loadImageShape.apply(this, arguments);
      }

      return loadImageShape;
    }()
  }]);

  return ImageDrawer;
}();
_ImageDrawer_images = new WeakMap();